import { render, staticRenderFns } from "./DealerRegistration.vue?vue&type=template&id=5f72f56a&"
import script from "./DealerRegistration.vue?vue&type=script&lang=js&"
export * from "./DealerRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports